import { getAiSpreadsheetCellDisplayValue } from "@/payroll/ai-script/ai-script-spreadsheet-viewer/cell-display-value";
import { getCellErrorCode } from "@/payroll/ai-script/ai-script-spreadsheet-viewer/utils";
import type { IAiSpreadsheetCell } from "@/payroll/ai-script/types";
import {
  buildThemeOverride,
  getContentAlign,
  hasSuggestedValueOptions,
  hasVisibleValue,
} from "./cell-format";
import { coordinateKey, type TextOverflowSpan } from "./types";

const canTextOverflow = (cell: IAiSpreadsheetCell) => {
  const displayData = getAiSpreadsheetCellDisplayValue(cell);
  const align = getContentAlign(cell);

  return (
    !getCellErrorCode(cell) &&
    !hasSuggestedValueOptions(cell) &&
    displayData !== "" &&
    !displayData.includes("\n") &&
    !cell.format?.alignment?.wrap_text &&
    (align === undefined || align === "left")
  );
};

export const buildTextOverflowSpans = (
  columnCount: number,
  cellsByCoordinate: Map<string, IAiSpreadsheetCell>,
): Map<string, TextOverflowSpan> => {
  const spans = new Map<string, TextOverflowSpan>();

  cellsByCoordinate.forEach((cell) => {
    if (!canTextOverflow(cell)) return;

    const sourceCol = cell.col - 1;
    let endColExclusive = sourceCol + 1;

    for (let col = sourceCol + 1; col < columnCount; col++) {
      const nextCell = cellsByCoordinate.get(coordinateKey(col + 1, cell.row));

      if (hasVisibleValue(nextCell)) break;

      endColExclusive = col + 1;
    }

    if (endColExclusive === sourceCol + 1) return;

    const span: TextOverflowSpan = {
      sourceCol,
      displayData: getAiSpreadsheetCellDisplayValue(cell),
      themeOverride: buildThemeOverride(cell),
    };

    for (let col = sourceCol; col < endColExclusive; col++) {
      spans.set(coordinateKey(col + 1, cell.row), span);
    }
  });

  return spans;
};
